import Vue from "vue";
import { createStore, Store } from "vuex";
import BaseMapStylesDialogModule, {
  BaseMapStylesState
} from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import ExploreV2Module, { ExploreV2State } from "./modules/ExploreV2Module";
import BaseMapDataPOIsModule, { BaseMapDataPOIsState } from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import BaseMapDataOverlaysModule, { BaseMapDataOverlaysState } from "../../base_map_dialog/store/modules/BaseMapDataOverlaysModule";

export interface RootState {
  mapStyles: BaseMapStylesState,
  exploreV2: ExploreV2State,
  mapDataOverlays: BaseMapDataOverlaysState,
  mapDataPOIs: BaseMapDataPOIsState
}

const store: Store<RootState> = createStore({
  modules: {
    mapStyles: BaseMapStylesDialogModule,
    exploreV2: ExploreV2Module,
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
  }
})

store.subscribe((mutation, state) => {
  if (
    mutation.type === 'exploreV2/setSearchString' ||
    mutation.type === 'exploreV2/setCenterAndZoom' ||
    mutation.type === 'exploreV2/setSearchSource'
  ) {
    store.dispatch('exploreV2/getTypesenseResponse')
  }
  if (
    mutation.type === 'exploreV2/setDistanceRangeMin' ||
    mutation.type === 'exploreV2/setDistanceRangeMax' ||
    mutation.type === 'exploreV2/setCommunityDurationRangeMin' ||
    mutation.type === 'exploreV2/setCommunityDurationRangeMax' ||
    mutation.type === 'exploreV2/setCommunityElevationRangeMin' ||
    mutation.type === 'exploreV2/setCommunityElevationRangeMax' ||
    mutation.type === 'exploreV2/setElevations' ||
    mutation.type === 'exploreV2/setDifficulties' ||
    mutation.type === 'exploreV2/removeTrailTag' ||
    mutation.type === 'exploreV2/addTrailTag' ||
    mutation.type === 'exploreV2/setSelectedTrailTags' ||
    mutation.type === 'exploreV2/removeActivityTag' ||
    mutation.type === 'exploreV2/addActivityTag' ||
    mutation.type === 'exploreV2/setSelectedActivityTags' ||
    mutation.type === 'exploreV2/removeFeatureTag' ||
    mutation.type === 'exploreV2/addFeatureTag' ||
    mutation.type === 'exploreV2/setSelectedFeatureTags' ||
    mutation.type === 'exploreV2/removeCommunityItemType' ||
    mutation.type === 'exploreV2/addCommunityItemType' ||
    mutation.type === 'exploreV2/setSelectedCommunityItemTypes' ||
    mutation.type === 'exploreV2/setRating' ||
    mutation.type === 'exploreV2/clearRating' ||
    mutation.type === 'exploreV2/setDurationRange' ||
    mutation.type === 'exploreV2/addTrailGeometryType' ||
    mutation.type === 'exploreV2/removeTrailGeometryType' ||
    mutation.type === 'exploreV2/setSelectedTrailGeometryTypes'
  ) {
    store.dispatch('exploreV2/getTypesenseResponse')
  }
  if (mutation.type === 'exploreV2/setTypesenseResponse') {
    store.dispatch('exploreV2/setClusterOnMapFromTypesenseResponse')
  }
  if (mutation.type === 'exploreV2/setTrail') {
    store.commit("exploreV2/setCountry", null)
    store.commit("exploreV2/setRegion", null)
    if (!store.state.exploreV2.isClusterNavActive) {
      store.dispatch('exploreV2/setTrailOnMap')
    }
  }
  if (mutation.type === 'exploreV2/setRecording') {
    store.commit("exploreV2/setCountry", null)
    store.commit("exploreV2/setRegion", null)
    if (!store.state.exploreV2.isClusterNavActive) {
      store.dispatch('exploreV2/setRecordingOnMap')
    }
  }
  if (mutation.type === 'exploreV2/setCountry') {
    store.dispatch('exploreV2/setCountryOnMap')
  }
  if (mutation.type === 'exploreV2/setRegion') {
    store.dispatch('exploreV2/setRegionOnMap')
  }
  if (mutation.type === 'exploreV2/setTrailEncodedPolyline') {
    store.dispatch('exploreV2/setTrailEncodedPolylineOnMap')
  }
})

export default store;
